export default "__VITE_ASSET__D5mNnzOT__"